import { GaugeConfig, GaugeSegment } from "./types";

export const CREDIT_SCORE_CONFIG: GaugeConfig = {
  viewBox: { width: 220, height: 120 },
  center: { x: 110, y: 100 }, // Center near bottom so arc curves upward into view
  radius: 70,
  strokeWidth: 8,
  minValue: 300,
  maxValue: 850
};

export const CREDIT_SCORE_LABELS_MIN_VALUES = [300, 580, 670, 740, 800];
export const CREDIT_SCORE_LABELS_MAX_VALUES = [579, 669, 739, 799, 850];

export const CREDIT_SCORE_LABELS = [
  CREDIT_SCORE_LABELS_MIN_VALUES[0],
  CREDIT_SCORE_LABELS_MIN_VALUES[1],
  CREDIT_SCORE_LABELS_MIN_VALUES[2],
  CREDIT_SCORE_LABELS_MIN_VALUES[3],
  CREDIT_SCORE_LABELS_MAX_VALUES[4]
];

export const EMPTY_SEGMENTS: GaugeSegment[] = [
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[0],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[0],
    color: "#1C1D2214",
    label: ""
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[1],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[1],
    color: "#1C1D2214",
    label: ""
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[2],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[2],
    color: "#1C1D2214",
    label: ""
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[3],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[3],
    color: "#1C1D2214",
    label: ""
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[4],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[4],
    color: "#1C1D2214",
    label: ""
  }
];

export const CREDIT_SCORE_SEGMENTS: GaugeSegment[] = [
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[0],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[0],
    color: "#f4423f",
    label: "Poor"
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[1],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[1],
    color: "#f4a107",
    label: "Fair"
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[2],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[2],
    color: "#409929",
    label: "Good"
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[3],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[3],
    color: "#52C535",
    label: "Very Good"
  },
  {
    min: CREDIT_SCORE_LABELS_MIN_VALUES[4],
    max: CREDIT_SCORE_LABELS_MAX_VALUES[4],
    color: "#5AD83A",
    label: "Excellent"
  }
];
